export const OvertimeRouting = [
  {
    path: "/attendance/overtime/list",
    name: "attendance-overtime-list",
    meta: { title: "加班申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-overtime" */ "@/views/attendance-management/overtime-application/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/overtime/create",
    name: "attendance-overtime-create",
    meta: { title: "新建加班申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-overtime" */ "@/views/attendance-management/overtime-application/form/form.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/overtime/edit/:id",
    name: "attendance-overtime-edit",
    meta: { title: "编辑加班申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-overtime" */ "@/views/attendance-management/overtime-application/form/form.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/overtime/detail/:id",
    name: "attendance-overtime-detail",
    meta: { title: "加班申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-overtime" */ "@/views/attendance-management/overtime-application/detail/detail.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/overtime/flowPrint/:id",
    name: "attendance-overtime-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-overtime" */ "@/views/attendance-management/overtime-application/flow-print/index.vue"
        ),
  },
];
